module.exports = __webpack_public_path__ + "img/40_38_062_430.51f1cf52.jpg";